import { mobileCountriesApi } from '@/api/common/site'
const state = {
  mobileCountries: [], // 全量国家区号列表
  countries: [] // 全量国家
}

const mutations = {
  SET_MOBILE_COUNTRIES: (state, list) => {
    state.mobileCountries = list
  },
  SET_COUNTRIES: (state, list) => {
    state.countries = list
  }
}

const actions = {
  // 国家区号列表
  async mobileCountries({ commit }, preload) {
    try {
      // debugger
      const res = await mobileCountriesApi({ siteCountryCode: preload?.siteCountryCode || preload?.country })
      const data = res.data
      const tmp = res.data.map(item => {
        const mobileAreaCode = `${item.countryCode}&${item.phoneCode}`
        if (preload && preload.country && preload.country === item.countryCode) {
          localStorage.setItem('mobileAreaCodeStorage', mobileAreaCode)
        }
        return {
          label: `(+${item.phoneCode})${item.countryNameI18n}`,
          value: mobileAreaCode
        }
      })
      commit('SET_MOBILE_COUNTRIES', tmp)
      commit('SET_COUNTRIES', data)
    } catch (error) {
      console.log(error)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

